@import '../utils/global.module.less';

.taskGroupTitle {
    align-self: center;
    color: #243a5c;
    font-size: 20px;
    font-family: LustTextItalic, serif !important;
    font-weight: 600;
    padding: 10px;
}

.taskGroup {
    border-top: 2px dashed #d0d5dd;
}

.flexsContainer {
    gap: 80px;
}

.taskBox {
    height: 54px;
    margin-top: 8px;
    border: 1px #eceef2 solid;
    border-radius: 15px;
    background-color: #ffffff;
    .small-shadow();
}

.iconSize {
    width: 28px;
    height: 28px;
}

.taskIcon {
    align-self: center;
    justify-self: center;
}

.taskTitle {
    cursor: pointer;
    color: #243a5c;
    font-size: 15px;
    font-family: Hanken Grotesk;
    font-weight: 600;
}

.taskStatus {
    color: #475467;
    font-size: 13px;
    font-family: Hanken Grotesk;
    font-weight: 400;
}

.taskBoxContent {
    padding: 5px 12px 5px 12px;
}

.taskViewContainer {
    width: calc(100% - 50px);
    height: 100%;
    position: absolute;
    background-color: white;
}

.clearButton {
    position: absolute;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
    &:hover {
        transform: scale(1.2);
    }
}
